export const colors = {
  ff_down_arrow_color: '#acacac',
  ff_up_arrow_color: '#434db8',
  ff_input_up_down_arrow_color: '#B2AEAE',
  white: '#ffffff',
  black: '#000000',
  grey_dark: '#727171',
  light_gray_50: '#F2F2F2',
  button_red_60: '#C50303',
};
